import "./sections/homepage/homepage.css";

import { MotionConfig } from "framer-motion";

import { DailyHabitSection } from "./sections/homepage/daily-habit-section";
import { EcosystemBridgeSection } from "./sections/homepage/ecosystem-bridge-section";
import { HeroSection } from "./sections/homepage/hero-section";
import { HowToStartSection } from "./sections/homepage/how-to-start-section";
import { IdentitySection } from "./sections/homepage/identity-section";
import { ProblemSection } from "./sections/homepage/problem-section";
import { SolutionsSection } from "./sections/homepage/solutions-section";
import { SpotlightSection } from "./sections/homepage/spotlight-section";

const HomePage = () => (
  <MotionConfig reducedMotion="user">
    <main className="marketing-page bg-[#f7f3e9] text-[#17233f]">
      <HeroSection />
      <ProblemSection />
      <IdentitySection />
      <SpotlightSection />
      <SolutionsSection />
      <DailyHabitSection />
      <EcosystemBridgeSection />
      <HowToStartSection />
    </main>
  </MotionConfig>
);

export { HomePage };
